import { Button, Col, Modal, Row } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Loader from 'components/layout/Loader';
import InputControl from 'components/inputs/InputControl';
import InputPricing from 'components/inputs/InputPricing';
import DashboardContext from 'Context';
/**
 * این کامپوننت برای نمایش مدال کار های پرستاری است که در جدول سفارشات است
 */
const ModalOrderCommisson = ({ sohwitem, handelClosemodal, id }) => {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);

  const [loading, setLoading] = useState(false);

  const [datafetch, setDatafetch] = useState({});

  const [dataFrom, setDataFrom] = useState({});

  const [lodinForm, setLodinForm] = useState(false);

  const dataFetching = async () => {
    setLoading(true);
    try {
      const res = await Axios.get(`${urldashboard}/ordercommission/get/${id}`, {
        headers: {
          Authorization: authentication,
          'content-type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.data.data;
      setDatafetch(data);
      setLoading(false);
    } catch (error) {
      handelerrors(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    dataFetching();
    return () => {};
  }, []);

  const sendData = async () => {
    try {
      const res = await Axios.post(
        `${urldashboard}/ordercommission/create`,
        JSON.stringify({ ...dataFrom, orderScheduleId: id }),
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );
      const data = await res.data;
      setLodinForm(false);
      toast.success(data.message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dataFetching();
    } catch (error) {
      setLodinForm(false);
      handelerrors(error);
    }
  };

  const handelValue = (name, vlaue) => {
    setDataFrom({ ...dataFrom, [name]: vlaue });
  };

  const handelSendForm = () => {
    setLodinForm(true);
    if (dataFrom.paymentInputType === undefined) {
      toast.error('لطفا نوع پرداخت را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodinForm(false);
    } else if (dataFrom.walletType === undefined) {
      toast.error('لطفا نوع تراکنش را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodinForm(false);
    } else if (dataFrom.paidAmount === undefined) {
      toast.error('لطفا مبلغ را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodinForm(false);
    } else {
      sendData();
    }
  };

  return (
    <Modal show={sohwitem} onHide={handelClosemodal}>
      <Modal.Header>
        <Modal.Title>پرداخت پورسانت پرستاری</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: '16px', cursor: 'pointer' }}
          onClick={handelClosemodal}
          aria-hidden='true'
        ></i>
      </Modal.Header>
      {loading ? (
        <Loader />
      ) : (
        <Modal.Body>
          <Row>
            <Col lg='6' md='6' sm='6' xs='12'>
              <p>
                کل مبلغ :{' '}
                <span>
                  {new Intl.NumberFormat('ja-JP', {
                    maximumSignificantDigits: 12,
                  }).format(datafetch.totalAmount)}
                </span>{' '}
                <small>ريال</small>
              </p>
            </Col>
            <Col lg='6' md='6' sm='6' xs='12'>
              <p>
                مبلغ پرداختی :{' '}
                <span>
                  {new Intl.NumberFormat('ja-JP', {
                    maximumSignificantDigits: 12,
                  }).format(datafetch.paidAmount)}
                </span>{' '}
                <small>ريال</small>
              </p>
            </Col>
            <Col lg='6' md='6' sm='6' xs='12'>
              <p>
                مانده مبلغ قابل پرداخت :{' '}
                <span>
                  {new Intl.NumberFormat('ja-JP', {
                    maximumSignificantDigits: 12,
                  }).format(datafetch.totalAmount - datafetch.paidAmount)}
                </span>{' '}
                <small>ريال</small>
              </p>
            </Col>
            <Col lg='6' md='6' sm='6' xs='12'>
              <p>
                تسویه شده است ؟{' '}
                {datafetch.isPaid ? (
                  <i className='fa fa-check' style={{ color: 'green' }}></i>
                ) : (
                  <i className='fa fa-times' style={{ color: 'red' }}></i>
                )}
              </p>
            </Col>
            <Col lg='12' md='12' sm='12' xs='12'>
              <p>بازپرداختها :</p>
              {datafetch.orderCommissionDetails
                ? datafetch.orderCommissionDetails.map((item) => (
                    <div
                      className='d-flex align-baseline border p-2 mb-2'
                      key={uuidv4()}
                    >
                      <p>
                        مبلغ :{' '}
                        <span>
                          {new Intl.NumberFormat('ja-JP', {
                            maximumSignificantDigits: 12,
                          }).format(item.amount)}
                        </span>{' '}
                        <small>ريال</small>
                      </p>
                      <p className='mx-auto'>ثبت کننده : {item.creatorName}</p>
                      <p>تاریخ ثبت : {item.persianCreateDate}</p>
                    </div>
                  ))
                : null}
            </Col>
          </Row>

          <Row>
            <Col lg='12' md='12' sm='12' xs='12'>
              <InputControl
                url='/common/paymentinputtypedropdown'
                disabled={datafetch.isPaid}
                label='نوع پرداخت'
                name='paymentInputType'
                handelValue={handelValue}
              />
            </Col>
            <Col lg='12' md='12' sm='12' xs='12'>
              <InputControl
                url='/common/wallettypedropdown'
                disabled={datafetch.isPaid}
                label='نوع تراکنش'
                name='walletType'
                handelValue={handelValue}
              />
            </Col>
            <Col lg='12' md='12' sm='12' xs='12'>
              <InputPricing
                name='paidAmount'
                disabled={datafetch.isPaid}
                handelValue={handelValue}
                label='مبلغ قسط'
              />
            </Col>
          </Row>
        </Modal.Body>
      )}
      <Modal.Footer>
        <Button
          disabled={lodinForm}
          onClick={handelClosemodal}
          variant='danger'
        >
          بستن
        </Button>
        <Button
          disabled={lodinForm ? lodinForm : datafetch.isPaid}
          onClick={handelSendForm}
          variant='success'
          className='mr-auto'
        >
          {lodinForm ? <i className='fa fa-spinner fa-pulse fa-fw'></i> : 'ثبت'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalOrderCommisson;
